import TermAccordion from '@components/term/TermAccordion';
import styled from '@emotion/styled';
import useTermCategories from '@hooks/term/useTermCategories';
import { TermDisplayContext } from '@models/term/termCategory';

interface Props {
    displayContext: TermDisplayContext;
    noMargin?: boolean;
}

function TermNotes({ displayContext, noMargin }:Props) {
    const termCategories = useTermCategories(displayContext);
    return (
        <Container noMargin={noMargin}>
            {termCategories.map((termCategory) => (
                <TermAccordion termCategory={termCategory}
                    key={termCategory.id}/>
            ))}
        </Container>
    );
}

const Container = styled.footer<{
    noMargin?: boolean;
}>`
    margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '48px')};
    width: 100%;
`;

export default TermNotes;
